/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, count: NonNullable<unknown> }} Offers_Per_MonthsInputs */

const en_offers_per_months = /** @type {(inputs: Offers_Per_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} every ${i?.count} months`)
};

const pl_offers_per_months = /** @type {(inputs: Offers_Per_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} co ${i?.count} mies.`)
};

/**
* | output |
* | --- |
* | "{price} every {count} months" |
*
* @param {Offers_Per_MonthsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_per_months = /** @type {((inputs: Offers_Per_MonthsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Per_MonthsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_per_months(inputs)
	return en_offers_per_months(inputs)
});